function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { watchUserLocation, stopUserLocationWatch, clearLocationCoords, getLocationCoords } from '../LocationModule';

/**
 * @class Oskari.mapframework.bundle.mapmodule.request.StartUserLocationTrackingRequestHandler
 * Handles StartUserLocationTrackingRequest requests
 */
Oskari.clazz.define('Oskari.mapframework.bundle.mapmodule.request.StartUserLocationTrackingRequestHandler', function (sandbox, mapmodule) {
  this.sandbox = sandbox;
  this.mapmodule = mapmodule;
  this._log = Oskari.log('StartUserLocationTrackingRequestHandler');
}, {
  handleRequest: function handleRequest(core, request) {
    this._log.debug('Start user location tracking');
    var me = this;
    var mapmodule = this.mapmodule;
    var opts = request.getOptions() || {};
    var focused = false;

    // clear previous
    this._clearLocationFromMap();
    clearLocationCoords();
    stopUserLocationWatch();
    var succesCb = function succesCb(pos) {
      var mapMoved = false;
      // move map to coordinates
      if (opts.centerMap === 'update' || opts.centerMap === 'single' && !focused) {
        mapMoved = mapmodule.centerMap(pos);
      }
      // zoom only once, skip if centerMap fails
      if (!focused && mapMoved) {
        focused = true;
        mapmodule.zoomToFitMeters(pos.accuracy * 4);
      }
      if (opts.addToMap === 'point') {
        me._addLocationToMap(pos, false, {
          featureStyle: opts.featureStyle,
          optionalStyles: opts.optionalStyles
        });
      } else if (opts.addToMap === 'path') {
        me._addPathToMap();
      } else if (opts.addToMap === 'location') {
        me._addLocationToMap(pos, true, {
          featureStyle: opts.featureStyle,
          optionalStyles: opts.optionalStyles
        });
      }
    };
    var errorCb = function errorCb(error) {
      me._log.warn('Failed to get user location', error);
      if (opts.addToMap === 'point') {
        me._clearLocation();
      }
    };
    watchUserLocation(succesCb, errorCb, opts);
  },
  // styles is undocumented "hidden feature" for testing purposes
  _addLocationToMap: function _addLocationToMap(pos) {
    var addAccuracy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var styles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var features = this.mapmodule.getLocationGeoJSON(pos, addAccuracy);
    var _styles$featureStyle = styles.featureStyle,
      requestedStyle = _styles$featureStyle === void 0 ? {} : _styles$featureStyle,
      _styles$optionalStyle = styles.optionalStyles,
      requestedAccuracyStyle = _styles$optionalStyle === void 0 ? {} : _styles$optionalStyle;
    var layerOptions = {
      layerId: 'USER_LOCATION_LAYER',
      clearPrevious: true,
      featureStyle: _objectSpread({
        fill: {
          color: 'rgba(57, 150, 237, 0.3)'
        },
        stroke: {
          color: '#0fd1fe',
          width: 2
        },
        image: {
          radius: 5,
          fill: {
            color: '#004d7f'
          }
        }
      }, requestedStyle)
    };
    if (addAccuracy) {
      var accuracyStyle = _objectSpread({
        property: {
          key: 'name',
          value: 'accuracy'
        },
        stroke: {
          color: 'rgba(38, 112, 181, 0.3)',
          width: 1
        },
        // without null image we get the default image
        image: null
      }, requestedAccuracyStyle);
      layerOptions.optionalStyles = [accuracyStyle];
    }
    Oskari.getSandbox().postRequestByName('MapModulePlugin.AddFeaturesToMapRequest', [features, layerOptions]);
  },
  _clearLocationFromMap: function _clearLocationFromMap() {
    Oskari.getSandbox().postRequestByName('MapModulePlugin.RemoveFeaturesFromMapRequest', [null, null, 'USER_LOCATION_LAYER']);
  },
  _addPathToMap: function _addPathToMap() {
    var coords = getLocationCoords();
    var path = this.mapmodule.getLocationPathGeoJSON(coords);
    if (!path) {
      return;
    }
    var featureStyle = {
      stroke: {
        color: 'rgba(38, 112, 181, 1)'
      }
    };
    var layerOptions = {
      layerId: 'USER_LOCATION_LAYER',
      clearPrevious: true,
      featureStyle: featureStyle
    };
    Oskari.getSandbox().postRequestByName('MapModulePlugin.AddFeaturesToMapRequest', [path, layerOptions]);
  }
}, {
  protocol: ['Oskari.mapframework.core.RequestHandler']
});